import lightTheme from '../LightTheme'
import WebThemeInterface from './WebThemeInterface'

const breakpoints = ['320px', '480px', '768px', '1024px', '1920px']

const webLightTheme: WebThemeInterface = {
    ...lightTheme,
    breakpoints,
}

export default webLightTheme
